import React from 'react';
import { Stack } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { NextPrevButton } from 'Components/NextPrevButton';

interface IActionButtons {
  handleBack: () => void;
  handleSubmit: () => void;
}

export const ActionButtons: React.FC<IActionButtons> = ({
  handleBack,
  handleSubmit,
}) => {
  const dictionary = Dictionary[DICTIONARY.UniversalRequest];

  return (
    <Stack
      direction='row'
      justifyContent='space-between'
      alignItems='center'
      gap='24px'
      mt={'40px'}
      mb={'80px'}
    >
      <NextPrevButton
        callback={handleBack}
        style={{ button: { p: '10px 33px 10px 31px' } }}
        text={dictionary.uploadFile.back}
      />

      <NextPrevButton
        callback={handleSubmit}
        style={{ button: { p: '10px 33px 10px 31px' } }}
        text={dictionary.uploadFile.submit}
        isNext
        isBlue
      />
    </Stack>
  );
};
